import Page from "../../components/Page";
import { useEffect, useState } from "react";
import AgentReportSection from "../../../src/components/Reports/New Progress Report/AgentReportSection";

export const AgentProgressReportPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.body.scrollHeight }
            console.log('height: ', obj);
            if (window.callbackHandler != undefined) {
                window.callbackHandler.postMessage(JSON.stringify(obj));
            } else if (window.webkit != undefined) {
                if (window.webkit.messageHandlers.callbackHandler != undefined) {
                    window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(obj));
                }
            }

        }, 3000)

        return (() => { clearInterval(sendHeight) })

    }, [])

    return (
        <>
            <Page>
                <AgentReportSection />
            </Page>
        </>
    )
}

export default AgentProgressReportPage;